import { ApiResponse } from './api-response';

export interface IPagedResponse<T> {
  pageNumber: number;
  pageSize: number;
  totalPages: number;
  totalRecords: number;
  response: T;
  messages: string[];
}

export class PagedResponse<T> extends ApiResponse<T> implements IPagedResponse<T> {
  pageNumber: number = 1;
  pageSize: number = 25;
  totalPages: number = 1;
  totalRecords: number = 0;

  constructor(success?: boolean, data?: IPagedResponse<T>) {
    super(success, data);
    if (data) {
      this.pageNumber = data.pageNumber;
      this.pageSize = data.pageSize;
      this.totalPages = data.totalPages;
      this.totalRecords = data.totalRecords;
    }
  }

  /**
   * Take an array as a data source, page size, and current page, and use those to
   * generate a PagedResponse object as if coming from the API.
   *
   * This is useful for replacing existing logic with calls to the NgRX store without
   * having to change how a component or service is interpreting the paged API response.
   */
  static fromArray<T>(source: T[], pageSize: number, pageNumber: number): PagedResponse<T[]> {
    const totalPages = Math.ceil(source.length / pageSize);
    const totalRecords = source.length;
    const actualPageNumber = Math.min(pageNumber, totalPages);
    const actualPageSize = Math.min(pageSize, totalRecords);
    const start = (actualPageNumber - 1) * actualPageSize;
    const end = actualPageNumber * actualPageSize;
    return new PagedResponse<T[]>(true, {
      totalPages,
      totalRecords,
      pageSize: actualPageSize,
      pageNumber: actualPageNumber,
      response: source.slice(start, end),
      messages: [],
    });
  }

  hasMore(): boolean {
    return this.pageSize * this.totalPages < this.totalRecords;
  }
}
